import { createFileRoute } from '@tanstack/react-router';
import ObjectTypeGuidePage from '@/pages/workspaces/objects/object-type-guide.page';
import { ObjectsMigrationRoute } from '@/pages/workspaces/objects/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/objects/$slug/guide')({
  component: () => (
    <ObjectsMigrationRoute>
      <ObjectTypeGuidePage />
    </ObjectsMigrationRoute>
  ),
});
